import React from 'react';
import AdContainer from 'src/components/ads';
import { MobileOnly } from 'src/ui/block';

export const MobileTopAd: React.FC = () => (
  <MobileOnly>
    <AdContainer
      placement="dubbelpanorama_top"
      min={0}
      max={860}
      format="toppanorama"
      spacing={{ top: '10px' }}
    />
  </MobileOnly>
);
